import {useQuery} from "react-query";
import { Contact } from '../Types/service';
import { getContactInformations } from '../Api/api';

export const useGetContactInfo = () => {
  return useQuery<any, any, Contact>(
      ['contactinfo', ],
      () => getContactInformations()
    );
}
